const LONDON_TIME_ZONE = 'Europe/London';

const WEEKDAY = {
    monday: 'Mon',
    tuesday: 'Tue',
    wednesday: 'Wed',
    thursday: 'Thu',
    friday: 'Fri',
    saturday: 'Sat',
};

const toMinutes = (hour: number, minute: number) => hour * 60 + minute;

const getLondonDateParts = (date: Date) => {
    const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: LONDON_TIME_ZONE,
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
    }).formatToParts(date);

    const getPart = (type: string) =>
        parts.find((part) => part.type === type)?.value || '';

    return {
        weekday: getPart('weekday'),
        minutes: toMinutes(Number(getPart('hour')), Number(getPart('minute'))),
    };
};

const isWithinRange = (minutes: number, start: number, end: number) =>
    minutes >= start && minutes < end;

export const isWithinFinaliseCallHours = (date: Date = new Date()) => {
    const { weekday, minutes } = getLondonDateParts(date);

    if (
        weekday === WEEKDAY.monday ||
        weekday === WEEKDAY.tuesday ||
        weekday === WEEKDAY.wednesday ||
        weekday === WEEKDAY.thursday
    ) {
        return isWithinRange(minutes, toMinutes(8, 30), toMinutes(19, 0));
    }

    if (weekday === WEEKDAY.friday || weekday === WEEKDAY.saturday) {
        return isWithinRange(minutes, toMinutes(9, 0), toMinutes(17, 0));
    }

    return false;
};
